<template>
    <div></div>
</template>
<script type="text/javascript">
    // let x = this.$common.commonNum
    let that = this;
    // 定义一些公共的属性
    const commonNum = 770;
    // 定义一些公共的方法
    function commonFun() {
        
    }
    // 暴露出这些属性和方法
    export default {
        commonNum,
        commonFun
    }
</script>